// src/component/common/FlagImage.jsx - Fixed version
import React from 'react';

const FlagImage = ({ countryCode, size = 24, className = "" }) => {
  // Add safety check for countryCode
  if (!countryCode || typeof countryCode !== 'string') {
    console.warn('FlagImage: countryCode is missing or invalid:', countryCode);
    return (
      <div 
        className={`bg-gray-200 rounded-sm flex items-center justify-center ${className}`}
        style={{ width: `${size}px`, height: `${size * 0.75}px` }}
      >
        <span className="text-gray-400 text-xs">?</span>
      </div>
    );
  }

  const lowerCaseCode = countryCode.toLowerCase();
  
  return (
    <img 
      src={`https://flagsapi.com/${lowerCaseCode}/flat/${size}.png`}
      alt={`${countryCode} flag`}
      className={`rounded-sm ${className}`}
      style={{ width: `${size}px`, height: `${size * 0.75}px` }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
};

export default FlagImage;